"use strict";
/*
 * Created on 11 01 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var StrategyTypeEnum_1 = require("../../general-settings/model/strategy/StrategyTypeEnum");

var ProductPrice_1 = require("../../product/model/ProductPrice");

var UserMessage_1 = require("../../user-messages/model/UserMessage");
/**
 * @author Jaroslav Sevcik
 * @author Radek Beran
 */


var ReferencePrice =
/*#__PURE__*/
function (_ProductPrice_1$Produ) {
  _inherits(ReferencePrice, _ProductPrice_1$Produ);

  /**
   * @param value
   * @param priceZoneId
   * @param productId
   * @param strategyType
   * @param messages messages for user describing source of computed price or another warnings
   */
  function ReferencePrice(value, priceZoneId, productId, strategyType, messages) {
    var _this;

    _classCallCheck(this, ReferencePrice);

    // LOG-5292: Setting VAT value to null, VAT is used only in regular/sellout/final prices
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReferencePrice).call(this, value, null));
    _this.value = value;
    _this.priceZoneId = priceZoneId;
    _this.productId = productId;
    _this.strategyType = strategyType;
    _this.messages = messages;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to reference price.
   */


  _createClass(ReferencePrice, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ReferencePrice(mat.value, mat.priceZoneId, mat.productId, mat.strategyType, mat.messages);
    }
  }]);

  return ReferencePrice;
}(ProductPrice_1.ProductPrice);

exports.ReferencePrice = ReferencePrice;
ReferencePrice.EMPTY_LIST = immutable_1.List.of(); // tslint:disable-next-line:member-ordering

ReferencePrice.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReferencePrice.name);
  return {
    value: builder.opt(builder.bigNum('value')),
    vatId: builder.opt(builder.str('vatId')),
    priceZoneId: builder.id('priceZoneId'),
    productId: builder.id('productId'),
    strategyType: builder.opt(builder.senum('strategyType', StrategyTypeEnum_1.StrategyTypeEnum, 'seq')),
    messages: builder.listOf(builder.obj('messages', UserMessage_1.UserMessage.schema, function (mat) {
      return UserMessage_1.UserMessage.fromDataDict(mat);
    }))
  };
}();